import { isNil } from 'lodash';
import { Carrier } from '~domain/model/core/carrier';
import DateTime from '~domain/model/core/date/datetime';
import { HomeLine } from '~domain/model/core/home-line';
import { ProductType } from '~domain/model/core/product-type';
import { PolicyAttachmentSummary } from '~domain/model/policy/policy-attachment-summary';
import { PolicyIssuance } from '~domain/model/policy/policy-issuance';
import { PolicySummary } from '~domain/model/policy/policy-summary';

export class PolicySummaryFacade {
  constructor(public readonly summary: PolicySummary) {}

  public get id(): string {
    return this.summary.id;
  }

  public get applicationId(): string {
    return this.summary.applicationId;
  }

  public get carrier(): Carrier {
    return this.summary.carrier;
  }

  public get effectiveDate(): DateTime {
    if (isNil(this.summary.effectiveDate)) {
      return;
    }

    return new DateTime(this.summary.effectiveDate);
  }

  public get expirationDate(): DateTime {
    if (isNil(this.summary.expirationDate)) {
      return;
    }

    return new DateTime(this.summary.expirationDate);
  }

  public get issuance(): PolicyIssuance {
    return this.summary.issuance;
  }

  public get policyNumber(): string {
    return this.summary.policyNumber;
  }

  public get productType(): ProductType {
    return this.summary.productType;
  }

  public get homeLine(): HomeLine | undefined {
    return this.summary.homeLine;
  }

  public get userAccountId(): string {
    return this.summary.userAccountId;
  }

  public get attachments(): PolicyAttachmentSummary[] {
    return this.summary.attachments;
  }

  public get isExpired(): boolean {
    return this.expirationDate.isDayInferiorThanTodaysOrEquals();
  }

  public isActiveAsOf(date: DateTime): boolean {
    if (this.issuance === PolicyIssuance.Pending) return false;

    return date.isDayGreaterToOrEqual(this.effectiveDate) && date.isDayInferior(this.expirationDate);
  }
}
